import React, {Component} from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import logo from '../Assets/logo.svg'
import ambassadorPicture from './../Assets/optilume_ambassador_8.png'
import {BACKGROUND} from '../Constants/cdn'
import Georgi from '../Assets/Georgi_Tosev.jpg'

import {Link, NavLink} from 'react-router-dom'

import CardMedia from '@material-ui/core/CardMedia'

// Components
import LanguageSelect from './LanguageSelect'
import AnchorLink from "react-anchor-link-smooth-scroll";
import AmbassadorLink from "./AmbassadorLink";

//                        style={{height: '145px', width: '100%', objectFit: 'inherit'}}                     <li><LanguageSelect language={language} /></li>

const Header = () => {
    const { t } = useTranslation()
    const language = useSelector(state => state.language)

    return (
        <header id="home">

            <nav id="nav-wrap">

                <a className="mobile-btn" href="/#nav-wrap" title="Show navigation">Показать навигацию</a>
                <a className="mobile-btn" href="/#home" title="Hide navigation">Скрыть навигацию</a>

                <ul id="nav" className="nav">
                    <li><AnchorLink href="#about" className="smoothscroll">{t('aboutUs')} </AnchorLink></li>
                    <li><AnchorLink href="#portfolio" className="smoothscroll">{t('services')}</AnchorLink></li>
                    <li><AnchorLink href="#contact" className="smoothscroll">{t('contacts')}</AnchorLink></li>

 
                </ul>

            </nav>

            <div className="row banner">
                <div className="banner-text">
                    <CardMedia
                        component='img'
                        image={logo}
                    style={
                        {
                            width: '50%',
                            objectFit: 'inherit',
                            objectPosition: 'bottom',
                            marginLeft: '24%',
                            marginTop: '3%',
                        }}
                    />
                </div>
                <AmbassadorLink/>
            </div>

            <p className="scrolldown">
                <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
            </p>

        </header>
    )
}

export default Header



// WEBPACK FOOTER //
// ./src/Components/Header.js